/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2023, Bulb Inc. For more information, please email contact@hellobulb.com.
*/
import { Component, Input } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslationService } from 'src/common/translation.service';
import { DialogConfig } from '../types';

/**
 * Reusable component that handles the header portion of standard aero dialogs.
 */
@Component({
  selector: 'aero-dialog-header',
  templateUrl: './dialog-header.component.html',
  styleUrls: ['./dialog-header.component.scss'],
  standalone: false,
})
export class DialogHeaderComponent {

  @Input() public config: DialogConfig;

  @Input() public dialogRef: DynamicDialogRef;

  public closeLabel: string;

  constructor(private $translate : TranslationService) {
    this.closeLabel = this.$translate.translateInstant('close_dialog');
  }
}
